import { useState } from 'react'
import { Link } from 'react-router-dom'
import './Trangchu.css'
import { BannerSlider, BannerSlide, ProjectGrid, CtaSection, Loader } from '../../components'
import useDocumentTitle from '../../hooks/useDocumentTitle'
import { useProjects } from '../../features/projects/hooks/useProjects'

const directorImg = new URL('../../assets/images/giam_doc_thi_cong_maxconst.png', import.meta.url).href
const directorSignature = new URL('../../assets/images/chuky_giamdoc.png', import.meta.url).href

// Bảng vật liệu chuẩn từ MaxHome
const MATERIAL_DATA = {
  tho: [
    { stt: '1', name: 'Đá xanh 1x2, đá 4x6', spec: 'Đá dăm chịu lực dầm sàn cột', origin: 'Khai thác thực tế tại địa phương' },
    { stt: '2', name: 'Cát vàng đổ bê tông', spec: 'Cát hạt lớn sạch tiêu chuẩn', origin: 'Khai thác thực tế tại địa phương' },
    { stt: '3', name: 'Cát đen đổ nền', spec: 'Cát san lấp', origin: 'Khai thác thực tế tại địa phương' },
    { stt: '4', name: 'Cát xây trát hoàn thiện', spec: 'Cánh to xây trát, cánh nhỏ hoàn thiện (sàng sạch)', origin: 'Khai thác thực tế tại địa phương' },
    { stt: '5', name: 'Xi măng Hoàng Thạch PC40', spec: 'PC40 xây trát, PCB40 đổ bê tông', origin: 'Hoàng Thạch chính hãng' },
    { stt: '6', name: 'Thép kết cấu chịu lực', spec: 'Thép Việt Nhật / Việt Pháp hoặc tương đương', origin: 'Thép Việt Nhật chính hãng' },
    { stt: '7', name: 'Gạch chỉ đặc xây tường A1', spec: 'Gạch đất sét nung mác cao', origin: 'Gạch tốt nhất địa phương' },
    { stt: '8', name: 'Chống thấm chuyên dụng Sika', spec: 'Lót Sika Latex, phủ Sikaproof Membrane', origin: 'Sika chính hãng (ban công, vệ sinh)' },
    { stt: '9', name: 'Bê tông thương phẩm (tươi)', spec: 'Bơm tĩnh mác bê tông theo hồ sơ thiết kế', origin: 'Trạm trộn bê tông địa phương uy tín' },
    { stt: '10', name: 'Dây dẫn điện trong nhà', spec: 'Dây đồng đơn/đôi bọc nhựa PVC', origin: 'Điện Trần Phú chính hãng' },
    { stt: '11', name: 'Gen ống cứng luồn dây', spec: 'Gen luồn dây điện chống chập cháy', origin: 'Vanlock hoặc tương đương' }
  ],
  dien: [
    { stt: '1', name: 'Công tắc điện hạt lớn', spec: 'Công tắc cơ hạt lớn dòng S182', origin: 'Sino chính hãng' },
    { stt: '2', name: 'Ổ cắm điện cao cấp', spec: 'Ổ cắm điện âm tường dòng S182', origin: 'Sino chính hãng' },
    { stt: '3', name: 'Tủ điện âm tường', spec: 'Tủ điện nhựa chứa CB 24 module K24', origin: 'Schneider chính hãng' },
    { stt: '4', name: 'Aptomat CB bảo vệ', spec: 'CB tép 1P, 2P dòng bảo vệ rò rỉ', origin: 'Sino chính hãng' }
  ],
  nuoc: [
    { stt: '1', name: 'Ống thoát nước PVC', spec: 'Ống PVC độ dày tiêu chuẩn C2', origin: 'Nhựa Tiền Phong chính hãng' },
    { stt: '2', name: 'Ống cấp nước nóng/lạnh PPR', spec: 'Ống hàn nhiệt chịu nhiệt độ áp suất cao', origin: 'Nhựa Tiền Phong chính hãng' },
    { stt: '3', name: 'Van khóa và vòi nước tổng', spec: 'Van khóa vòi đồng chịu áp cực bền', origin: 'Minh Hòa chính hãng' },
    { stt: '4', name: 'Phao cơ chống tràn bể nước', spec: 'Phao cơ tự động ngắt nước tràn bể', origin: 'Phao Bách Khoa chính hãng' },
    { stt: '5', name: 'Máy bơm nước chân không', spec: 'Máy bơm GP-200JXK công suất lớn', origin: 'Panasonic (Nhập khẩu Indonesia)' },
    { stt: '6', name: 'Máy bơm tăng áp tự động', spec: 'Bơm tăng áp tự động A130JAK ổn định dòng nước', origin: 'Panasonic (Nhập khẩu Indonesia)' },
    { stt: '7', name: 'Téc chứa nước sạch inox', spec: 'Téc inox 304 dung tích 1500L', origin: 'Sơn Hà chính hãng' },
    { stt: '8', name: 'Ga thoát sàn ban công', spec: 'Ga thoát sàn ngoài trời ngăn rác', origin: 'Caesar chính hãng' },
    { stt: '9', name: 'Ga thoát sàn ngăn mùi hôi', spec: 'Thoát sàn Inox SUS304 mờ MN-T219', origin: 'SUS304 mờ cao cấp' },
    { stt: '10', name: 'Bình nước nóng gián tiếp', spec: 'Bình nóng lạnh 20L chống giật', origin: 'Ariston chính hãng' },
    { stt: '11', name: 'Quạt hút mùi âm trần WC', spec: 'Quạt thông gió âm trần mã FV-20CTU1', origin: 'Panasonic (Nhập khẩu Thái Lan)' },
    { stt: '12', name: 'Hệ thống đèn ngoài trời', spec: 'Đèn LED gắn tường chiếu sáng trang trí ngoại thất', origin: 'Nhập khẩu cao cấp' }
  ],
  hoanthien: [
    { stt: '1', name: 'Trần thạch cao chịu ẩm', spec: 'Khung xương ECO Vĩnh Tường, tấm chịu ẩm Vĩnh Tường 9mm', origin: 'Vĩnh Tường chính hãng' },
    { stt: '2', name: 'Bột bả tường nội ngoại thất', spec: 'Bột bả siêu mịn, tăng độ liên kết sơn', origin: 'Sơn cao cấp Maxhome' },
    { stt: '3', name: 'Sơn phủ màu nội ngoại thất', spec: 'Sơn nước phủ bóng cao cấp bền màu, kháng kiềm', origin: 'Sơn cao cấp Maxhome' },
    { stt: '4', name: 'Gạch lát nền tầng 1', spec: 'Gạch Porcelain mài bóng kích thước 600x600', origin: 'Thạch Bàn chính hãng' },
    { stt: '5', name: 'Gạch lát nền tầng 2', spec: 'Gạch Porcelain mài bóng kích thước 600x600', origin: 'Thạch Bàn chính hãng' },
    { stt: '6', name: 'Gạch ốp lát nhà vệ sinh', spec: 'Gạch Ceramic mài cạnh kích thước 300x600', origin: 'Giá định mức 180.000đ/m2' },
    { stt: '7', name: 'Gạch lát sàn ban công', spec: 'Gạch men mát chống trơn trượt 300x600', origin: 'Thạch Bàn chính hãng' },
    { stt: '8', name: 'Gạch thẻ ốp trang trí sảnh', spec: 'Gạch thẻ ngoại thất chịu thời tiết', origin: 'Thạch Bàn (Giá định mức 250.000đ/m2)' },
    { stt: '9', name: 'Cầu thang gỗ tự nhiên', spec: 'Mặt bậc, con tiện, tay vịn D60 gỗ Lim', origin: 'Gỗ Lim Nam Phi cao cấp (Cổ bậc đá trắng)' },
    { stt: '10', name: 'Hệ thống đèn LED âm trần', spec: 'Đèn mắt trâu LED Downlight 7W viền bạc', origin: 'Kingled chính hãng' },
    { stt: '11', name: 'Cửa đi, cửa thông phòng', spec: 'Cửa gỗ pano đặc/kính theo bản vẽ thiết kế', origin: 'Gỗ Lim Nam Phi tự nhiên cao cấp' },
    { stt: '12', name: 'Cửa sổ nhôm kính ngoại thất', spec: 'Khung nhôm Xingfa cao cấp, kính an toàn 6.38mm', origin: 'Nhôm Xingfa nhập khẩu chính hãng' },
    { stt: '13', name: 'Hệ thống đèn LED dây', spec: 'Đèn LED dây trang trí hắt khe trần thạch cao', origin: 'Kingled chính hãng' },
    { stt: '14', name: 'Điều hòa không khí phòng ngủ', spec: 'Điều hòa treo tường 1 chiều inverter', origin: 'Daikin chính hãng' },
    { stt: '15', name: 'Đá ốp tam cấp và sảnh chính', spec: 'Đá Granite chịu mài mòn, độ bền cao', origin: 'Đá Granite Kim Sa Đen hoặc tương đương' },
    { stt: '16', name: 'Đèn hắt ngoại thất cột', spec: 'Đèn LED gắn cột chiếu sáng 2 chiều đứng', origin: 'Nhập khẩu cao cấp' },
    { stt: '17', name: 'Hệ thống cột thu lôi chống sét', spec: 'Kim thu sét, cáp đồng bọc nhựa tiếp địa đất', origin: 'Hệ thống chống sét kỹ thuật' }
  ],
  sanitary: [
    { stt: '1', name: 'Bồn cầu hai khối xả xoáy', spec: 'Bồn cầu sứ trắng xả nhấn mã C838VN', origin: 'Inax chính hãng' },
    { stt: '2', name: 'Sen tắm nóng lạnh cao cấp', spec: 'Bộ sen vòi tắm nóng lạnh mã BFV-2013S', origin: 'Inax chính hãng' },
    { stt: '3', name: 'Chậu rửa Lavabo treo tường', spec: 'Chậu lavabo treo tường men sứ trắng mã L285V', origin: 'Inax chính hãng' },
    { stt: '4', name: 'Vòi chậu rửa lavabo nóng lạnh', spec: 'Vòi gật gù lavabo nóng lạnh mã LFV1102S-1', origin: 'Inax chính hãng' },
    { stt: '5', name: 'Bàn đá chậu rửa lavabo', spec: 'Bàn đá Granite tự nhiên đỡ chậu lavabo', origin: 'Đá kim sa đen tự nhiên' },
    { stt: '6', name: 'Thanh treo khăn nhà tắm', spec: 'Thanh vắt khăn đôi mã KF-415VW', origin: 'Inax chính hãng' },
    { stt: '7', name: 'Hộp đựng giấy vệ sinh', spec: 'Hộp giấy sứ âm tường/nổi mã H486V', origin: 'Inax chính hãng' },
    { stt: '8', name: 'Đèn sưởi nhà vệ sinh', spec: 'Đèn sưởi âm trần 1 bóng sưởi ấm mùa đông', origin: 'Navado chính hãng' },
    { stt: '9', name: 'Hệ khung vì kèo mái ngói', spec: 'Vì kèo thép kẽm hộp nhẹ kẽm chống rỉ', origin: 'Thép hộp kẽm chống rỉ sét' },
    { stt: '10', name: 'Ngói lợp mái nhà biệt thự', spec: 'Ngói sóng cao cấp, công nghệ ép ướt Nhật', origin: 'Ngói Inari công nghệ Nhật Bản' }
  ]
}

const MaterialsModal = ({ 
  onClose, 
  activeTab, 
  setActiveTab 
}: { 
  onClose: () => void; 
  activeTab: string; 
  setActiveTab: (tab: any) => void;
}) => {
  const tabs = [
    { id: 'tho', label: 'Vật Tư Phần Thô' },
    { id: 'dien', label: 'Thiết Bị Điện' },
    { id: 'nuoc', label: 'Thiết Bị Nước' },
    { id: 'hoanthien', label: 'Vật Tư Hoàn Thiện' },
    { id: 'sanitary', label: 'Thiết Bị Vệ Sinh & Mái' }
  ]

  const currentData = MATERIAL_DATA[activeTab as keyof typeof MATERIAL_DATA] || []

  return (
    <div className="materials-modal-overlay" onClick={onClose}>
      <div className="materials-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="materials-modal-header">
          <h3>
            <i className="fas fa-clipboard-list" style={{ color: 'var(--color-primary)', marginRight: '8px' }}></i> 
            DANH SÁCH VẬT LIỆU THI CÔNG TRÒN GÓI MAXHOME CHUẨN
          </h3>
          <button className="materials-modal-close-btn" onClick={onClose}>&times;</button>
        </div>
        
        <div className="materials-modal-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`materials-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id as any)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        
        <div className="materials-modal-body">
          <div className="materials-table-wrapper">
            <table className="materials-table">
              <thead>
                <tr>
                  <th style={{ width: '60px' }}>STT</th>
                  <th>Tên / Mã vật tư</th>
                  <th>Quy cách / Chủng loại</th>
                  <th>Cam kết xuất xứ thương hiệu</th>
                </tr>
              </thead>
              <tbody>
                {currentData.map((item, idx) => (
                  <tr key={idx}>
                    <td><strong>{item.stt}</strong></td>
                    <td style={{ color: 'var(--color-text)', fontWeight: '600' }}>{item.name}</td>
                    <td>{item.spec}</td>
                    <td>
                      <span className="badge-commitment" style={{ 
                        backgroundColor: 'var(--color-primary-pale)', 
                        color: 'var(--color-primary-dark)', 
                        padding: '4px 8px', 
                        borderRadius: '4px', 
                        fontSize: '0.75rem', 
                        fontWeight: 'bold',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px'
                      }}>
                        <i className="fas fa-check-circle"></i> {item.origin}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        
        <div className="materials-modal-footer">
          <p><i className="fas fa-shield-alt" style={{ color: 'var(--color-primary)' }}></i> MAXCONST cam kết 100% sử dụng vật tư chính hãng, phát hiện sai phạm đền bù gấp đôi.</p>
          <a
            href="https://docs.google.com/spreadsheets/d/e/2PACX-1vS98Q4Y873mErPQMp_Oi9XzCi9CM6z08og8DHMUITPi_-05SpIgR0ABR1VIWtiOwQ/pubhtml"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-secondary materials-download-btn"
            style={{ textDecoration: 'none' }}
          >
            <i className="fas fa-external-link-alt"></i> Xem bảng Excel gốc
          </a>
        </div>
      </div>
    </div>
  )
}

const TrangchuPage = () => {
  useDocumentTitle('MAXCONST - Thiết Kế & Thi Công Nhà Đẹp Trọn Gói')
  const [showModal, setShowModal] = useState(false)
  const [activeTab, setActiveTab] = useState<'tho' | 'dien' | 'nuoc' | 'hoanthien' | 'sanitary'>('tho')

  // Fetch projects from 'cap4' category to display as featured
  const { projects, loading, error } = useProjects({ category: 'cap4', pages: 1 })
  const featuredProjects = projects.slice(0, 8)

  // Banner Slides
  const bannerSlides: BannerSlide[] = [
    {
      id: 1,
      image: new URL('../../assets/images/anh-banner-giam-sat-thanh-tra-1920x680.jpg', import.meta.url).href
    },
    {
      id: 2,
      image: new URL('../../assets/images/ung-dung-cong-nghe-moi.png', import.meta.url).href
    }
  ]

  return (
    <div className="trangchu-page">
      {/* Banner Slider */}
      <BannerSlider slides={bannerSlides} />

      {/* Intro Section */}
      <section className="intro-section section">
        <div className="container">
          <span className="home-subtitle">GIỚI THIỆU CHUNG</span>
          <h2>GIẢI PHÁP THIẾT KẾ & THI CÔNG TRỌN GÓI XUẤT SẮC</h2>
          <div className="colored-separator">
            <div className="first-long"></div>
            <div className="last-short"></div>
          </div>
          <p>
            Chào mừng bạn đến với **MAXCONST**, thương hiệu thành viên trực thuộc hệ sinh thái **MAXHOME Group**. 
            Chúng tôi tự hào kế thừa năng lực kỹ thuật vượt trội và quy trình quản lý chất lượng nghiêm ngặt của tập đoàn mẹ, 
            chuyên cung cấp các giải pháp thiết kế kiến trúc hiện đại, khoa học phong thủy sâu sắc và thi công xây dựng trọn gói hoàn mỹ. 
            Mỗi ngôi nhà do MAXCONST kiến tạo không chỉ là một công trình vững chắc bền vững theo thời gian mà còn là tổ ấm 
            ngập tràn sinh khí và thịnh vượng cho gia chủ.
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section section bg-alt">
        <div className="container">
          <div className="section-header text-center">
            <span className="section-subtitle">DỊCH VỤ CỦA CHÚNG TÔI</span>
            <h2 className="section-title">Hạng Mục Thiết Kế & Thi Công Trọng Điểm</h2>
            <div className="colored-separator">
              <div className="first-long"></div>
              <div className="last-short"></div>
            </div>
          </div>

          <div className="services-grid">
            <Link to="/nha-vuon" className="service-card">
              <div className="service-icon">
                <i className="fas fa-home" />
              </div>
              <h3 className="service-title">Thiết Kế Nhà Vườn</h3>
              <p className="service-desc">Không gian sống xanh mát, hòa hợp thiên nhiên với sân vườn rộng rãi và kiến trúc mái Nhật, mái Thái hiện đại.</p>
              <span className="service-link-btn">Xem thêm <i className="fas fa-arrow-right" /></span>
            </Link>

            <Link to="/nha-pho" className="service-card">
              <div className="service-icon">
                <i className="fas fa-building" />
              </div>
              <h3 className="service-title">Thiết Kế Nhà Phố</h3>
              <p className="service-desc">Tối ưu công năng, hiện đại hóa mặt tiền cho các công trình nhà ống phố hẹp, đảm bảo thông gió và ánh sáng.</p>
              <span className="service-link-btn">Xem thêm <i className="fas fa-arrow-right" /></span>
            </Link>

            <Link to="/biet-thu" className="service-card">
              <div className="service-icon">
                <i className="fas fa-hotel" />
              </div>
              <h3 className="service-title">Thiết Kế Biệt Thự</h3>
              <p className="service-desc">Khẳng định đẳng cấp gia chủ qua các thiết kế biệt thự tân cổ điển, hiện đại sang trọng và bề thế.</p>
              <span className="service-link-btn">Xem thêm <i className="fas fa-arrow-right" /></span>
            </Link>

            <Link to="/noi-that" className="service-card">
              <div className="service-icon">
                <i className="fas fa-couch" />
              </div>
              <h3 className="service-title">Thiết Kế Nội Thất</h3>
              <p className="service-desc">Kiến tạo không gian nội thất sang trọng, ấm cúng và thông minh, thể hiện phong cách riêng biệt của gia chủ.</p>
              <span className="service-link-btn">Xem thêm <i className="fas fa-arrow-right" /></span>
            </Link>
          </div>
        </div>
      </section>

      {/* Director Commitment Section */}
      <section className="director-section section">
        <div className="container">
          <div className="director-grid">
            <div className="director-image-wrapper">
              <div className="director-image-glow" />
              <div className="director-image-card">
                <img src={directorImg} alt="Giám đốc thi công MAXCONST" className="director-img" />
              </div>
              <div className="director-badge">
                <div className="director-signature-container">
                  <img src={directorSignature} alt="Chữ ký Nguyễn Kim Hùng" className="director-signature" />
                </div>
                <div className="director-info-container">
                  <span className="director-name">Nguyễn Kim Hùng</span>
                  <span className="director-title">Giám đốc thi công</span>
                </div>
              </div>
            </div>

            <div className="director-content">
              <span className="director-subtitle">CAM KẾT TỪ BAN GIÁM ĐỐC</span>
              <h2 className="director-main-title">Chất Lượng Vững Chãi – Thi Công Tận Tâm</h2>
              <div className="colored-separator text-left">
                <div className="first-long"></div>
                <div className="last-short"></div>
              </div>
              <p className="director-quote">
                "Tại MAXCONST, chúng tôi coi mỗi công trình là một tác phẩm nghệ thuật, một ngôi nhà mơ ước cả đời của gia chủ. 
                Chúng tôi cam kết thi công đúng kỹ thuật, sử dụng 100% vật tư chính hãng và đồng hành cùng khách hàng trong suốt vòng đời công trình."
              </p>

              <div className="commitment-list">
                <div className="commitment-item">
                  <div className="commitment-icon">
                    <i className="fas fa-shield-alt" />
                  </div>
                  <div className="commitment-text">
                    <h4>Bảo Hành Lên Tới 10 Năm</h4>
                    <p>Cam kết bảo hành khung xương kết cấu 10 năm và phần hoàn thiện 2 năm, hỗ trợ bảo trì trọn đời.</p>
                  </div>
                </div>

                <div className="commitment-item">
                  <div className="commitment-icon">
                    <i className="fas fa-clipboard-check" />
                  </div>
                  <div className="commitment-text">
                    <h4>Vật Tư Chuẩn Chính Hãng</h4>
                    <p>Cam kết sử dụng đúng chủng loại vật tư chính hãng theo hợp đồng, phát hiện sai phạm đền 100% giá trị.</p>
                  </div>
                </div>

                <div className="commitment-item">
                  <div className="commitment-icon">
                    <i className="fas fa-user-shield" />
                  </div>
                  <div className="commitment-text">
                    <h4>Giám Sát Chặt Chẽ 24/7</h4>
                    <p>Kỹ sư giám sát trực tiếp tại hiện trường và hệ thống camera trực tuyến giúp chủ nhà theo dõi tiến độ.</p>
                  </div>
                </div>

                <div className="commitment-item">
                  <div className="commitment-icon">
                    <i className="fas fa-hand-holding-usd" />
                  </div>
                  <div className="commitment-text">
                    <h4>Không Phát Sinh Chi Phí</h4>
                    <p>Báo giá bóc tách khối lượng chính xác tuyệt đối, ký hợp đồng trọn gói cam kết không phát sinh 1 đồng.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <i className="fas fa-briefcase stat-icon" />
              <span className="stat-number">500+</span>
              <span className="stat-title">Dự án hoàn thành</span>
            </div>
            <div className="stat-card">
              <i className="fas fa-users stat-icon" />
              <span className="stat-number">450+</span>
              <span className="stat-title">Khách hàng tin tưởng</span>
            </div>
            <div className="stat-card">
              <i className="fas fa-award stat-icon" />
              <span className="stat-number">10+</span>
              <span className="stat-title">Năm kinh nghiệm</span>
            </div>
            <div className="stat-card">
              <i className="fas fa-smile stat-icon" />
              <span className="stat-number">98%</span>
              <span className="stat-title">Khách hàng hài lòng</span>
            </div>
          </div>
        </div>
      </section>

      {/* Working Process Section */}
      <section className="process-section section">
        <div className="container">
          <div className="section-header text-center">
            <span className="section-subtitle">QUY TRÌNH LÀM VIỆC</span>
            <h2 className="section-title">Các Bước Kiến Tạo Tổ Ấm Chuẩn Mực</h2>
            <div className="colored-separator">
              <div className="first-long"></div>
              <div className="last-short"></div>
            </div>
          </div>

          <div className="process-grid">
            <div className="process-step">
              <div className="step-number">01</div>
              <h4 className="step-title">Tiếp Nhận & Tư Vấn</h4>
              <p className="step-desc">Khảo sát khu đất thực tế, lắng nghe mong muốn của gia chủ và tư vấn sơ bộ phương án mặt bằng kết hợp phong thủy.</p>
            </div>

            <div className="process-step">
              <div className="step-number">02</div>
              <h4 className="step-title">Thiết Kế Sơ Bộ</h4>
              <p className="step-desc">Lên phương án mặt bằng công năng chi tiết và phối cảnh 3D ngoại thất để chủ đầu tư phê duyệt định hướng.</p>
            </div>

            <div className="process-step">
              <div className="step-number">03</div>
              <h4 className="step-title">Hồ Sơ Kỹ Thuật</h4>
              <p className="step-desc">Triển khai chi tiết bản vẽ kiến trúc, kết cấu dầm sàn, hệ thống điện nước MEP và xin cấp phép xây dựng.</p>
            </div>

            <div className="process-step">
              <div className="step-number">04</div>
              <h4 className="step-title">Báo Giá & Ký Kết</h4>
              <p className="step-desc">Lập bảng bóc tách vật tư dự toán chi tiết không phát sinh. Ký kết hợp đồng thi công trọn gói minh bạch.</p>
            </div>

            <div className="process-step">
              <div className="step-number">05</div>
              <h4 className="step-title">Thi Công Xây Dựng</h4>
              <p className="step-desc">MAXCONST trực tiếp thi công thô và hoàn thiện nội ngoại thất dưới sự giám sát chặt chẽ của Giám đốc thi công.</p>
            </div>

            <div className="process-step">
              <div className="step-number">06</div>
              <h4 className="step-title">Bàn Giao & Bảo Hành</h4>
              <p className="step-desc">Nghiệm thu vệ sinh công nghiệp bàn giao chìa khóa trao tay. Cam kết bảo hành phần khung kết cấu lên tới 10 năm.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Materials Commitment Section */}
      <section className="materials-section section bg-alt">
        <div className="container">
          <div className="section-header text-center">
            <span className="section-subtitle">VẬT LIỆU CHÍNH HÃNG</span>
            <h2 className="section-title">Cam Kết Chủng Loại Vật Tư Chất Lượng Cao</h2>
            <div className="colored-separator">
              <div className="first-long"></div>
              <div className="last-short"></div>
            </div>
            <p className="materials-header-desc">
              MAXCONST cam kết 100% sử dụng vật tư chính hãng, đúng thương hiệu đã ký kết trong phụ lục hợp đồng, mang lại độ vững chãi trường tồn.
            </p>
          </div>

          <div className="materials-grid">
            <div className="material-brand-card">
              <span className="material-category">SẮT THÉP</span>
              <h4>Thép Việt Nhật / Việt Pháp</h4>
              <p>Thép chất lượng cao đạt chuẩn quốc gia, đóng vai trò khung xương chịu lực vững chãi vững bền theo năm tháng.</p>
            </div>

            <div className="material-brand-card">
              <span className="material-category">XI MĂNG</span>
              <h4>Xi Măng Hoàng Thạch PC40</h4>
              <p>Dòng xi măng mác cao chuyên dùng đổ bê tông tươi và xây tô chống thấm nước vượt trội cho tường bao.</p>
            </div>

            <div className="material-brand-card">
              <span className="material-category">SƠN & TRẦN THẠCH CAO</span>
              <h4>Sơn Maxhome / Trần Vĩnh Tường</h4>
              <p>Sơn màu nội ngoại thất cao cấp Maxhome kết hợp trần thạch cao khung xương ECO Vĩnh Tường tấm chịu ẩm 9mm.</p>
            </div>

            <div className="material-brand-card">
              <span className="material-category">THIẾT BỊ ĐIỆN & NƯỚC</span>
              <h4>Trần Phú / Tiền Phong / Sino</h4>
              <p>Dây điện Trần Phú luồn gen cứng Vanlock, thiết bị điện Sino hạt lớn và hệ thống cấp thoát nước nhựa Tiền Phong.</p>
            </div>

            <div className="material-brand-card">
              <span className="material-category">THIẾT BỊ VỆ SINH</span>
              <h4>INAX Cao Cấp</h4>
              <p>Thiết bị vệ sinh men sứ trắng sáng kháng khuẩn dễ lau chùi, phụ kiện inox không gỉ sang trọng hãng INAX.</p>
            </div>

            <div className="material-brand-card">
              <span className="material-category">GẠCH XÂY & CỬA GỖ</span>
              <h4>Thạch Bàn / Gỗ Lim / Xingfa</h4>
              <p>Gạch lát nền Thạch Bàn, cầu thang và cửa đi gỗ Lim Nam Phi sang trọng cùng hệ cửa sổ nhôm Xingfa kính an toàn.</p>
            </div>
          </div>

          <div className="materials-view-details-btn-wrapper">
            <button 
              className="materials-view-details-btn"
              onClick={() => setShowModal(true)}
            >
              <i className="fas fa-file-invoice-dollar" style={{ marginRight: '8px' }}></i> 
              Xem chi tiết bảng vật tư trọn gói
            </button>
          </div>
        </div>
      </section>

      {/* Featured Projects Section */}
      <section className="featured-projects-section section">
        <div className="container">
          <div className="section-header text-center">
            <span className="section-subtitle">DỰ ÁN TIÊU BIỂU</span>
            <h2 className="section-title">Các Công Trình Đã Thiết Kế & Thi Công</h2>
            <div className="colored-separator">
              <div className="first-long"></div>
              <div className="last-short"></div>
            </div>
          </div>

          <div className="home-projects-container">
            {loading ? (
              <Loader text="Đang tải danh sách công trình..." />
            ) : error ? (
              <p className="text-center text-danger">{error}</p>
            ) : (
              <ProjectGrid projects={featuredProjects} />
            )}
          </div>

          <div className="view-more-container text-center">
            <Link to="/cong-trinh-thiet-ke" className="btn btn-primary home-view-more-btn">
              Xem tất cả thiết kế <i className="fas fa-arrow-right" />
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <CtaSection 
        title="Đồng Hành Cùng MAXCONST Xây Dựng Ngôi Nhà Mơ Ước"
        titleHighlight="Đồng Hành Cùng MAXCONST"
        description="Liên hệ ngay với đội ngũ kiến trúc sư và chuyên gia phong thủy của chúng tôi để nhận báo giá chi tiết và phương án thiết kế tối ưu."
      />

      {/* Materials Modal Popup */}
      {showModal && (
        <MaterialsModal 
          activeTab={activeTab} 
          setActiveTab={setActiveTab} 
          onClose={() => setShowModal(false)} 
        />
      )}
    </div>
  )
}

export default TrangchuPage
